exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.md-tabs[data-v-a47da8cc] {\n  margin: 1rem auto 0;\n  max-width: 1440px;\n}\n.md-tab[data-v-a47da8cc] {\n  padding: 0;\n}\n.contracts__not-available-description[data-v-a47da8cc] {\n  margin: 0 auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a47da8cc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/contracts/index/Contracts.Index.vue
// module id = Pl/L
// module chunks = 1